  <div class="d-flex date-bar-container" data-test="date-bar">
    <div
      *ngFor="let item of items; let i = index; trackBy: trackById"
      class="date-item flex-fill text-center subhead primary-color-text-hover"
      [ngClass]="{ 'list-seven': items.length >= 7 }"
      [attr.data-test]="'date-bar-item-' + (i + 1)"
      [ngSwitch]="item.type"
    >
      <a
        *ngSwitchCase="'link'"
        [floCustomLink]="item.url"
        floAnalytics
        [analyticsProperties]="item.action"
        eventName="Filter Clicked"
        class="align-middle w-100 d-block color-600 apply-text-hover"
        [ngClass]="{ 'selected color-ignite border-bottom primary-color-border-bottom': item.state === 'selected' }"
        [attr.data-test]="'date-bar-item-' + item.state === 'selected'"
      >
        <span>{{ item.title | uppercase }}</span>
      </a>
      <a
        *ngSwitchCase="'tab'"
        [floCustomLink]="item.action.url"
        floAnalytics
        [analyticsProperties]="item.action.analytics"
        eventName="Filter Clicked"
        class="align-middle w-100 d-block color-600 apply-text-hover"
        [ngClass]="{ 'selected color-ignite border-bottom primary-color-border-bottom': item.active }"
        [attr.data-test]="'date-bar-item-' + item.active"
      >
        <span>{{ item.title | uppercase }}</span>
      </a>
    </div>
  </div>
